import cl from "./Caption.module.css"
import gl from "../../../styles/Global.module.css";

const Caption = ({children}) => {
  return (
    <div className={[cl.caption, gl.noselect].join(" ")}>{children}</div>
  )
}

export default Caption